import { GetReferencesCommand } from '@commands/backend';

export function ReferencesInitializerFactory(getReferencesCommand: GetReferencesCommand) {
  return () => getReferencesCommand.execute();
}
